import React, { Fragment, useEffect, useState } from "react";
import { Col, Row, Container, Card, Button, Nav, Tab } from "react-bootstrap";
import { getCourseDetails } from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import { CircularProgress } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import CommonHeader from "layouts/dashboard/CommonHeader";
import courseIcon from "../../../../assets/images/Courses.svg";
import GKAccordionProgress from 'components/marketing/common/accordions/GKAccordionProgress';

import HeaderDefault from "layouts/dashboard/HeaderDefault";

const AboutCourse = () => {
    const { courseId } = useParams();
    const [courseDetails, setCourseDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cookies] = useCookies();
    const navigate = useNavigate(); // Hook for navigation

    useEffect(() => {
        document.body.className = 'bg-light';
        const fetchCourseDetails = async () => {
            try {
                setLoading(true);
                const userId = cookies.userId;

                if (!courseId || !userId) {
                    throw new Error("Missing courseId or userId");
                }

                const response = await getCourseDetails(courseId, userId);
                console.log("Course Details:", response);

                if (response && response.data) {
                    setCourseDetails(response.data);
                } else {
                    throw new Error("Invalid response from server");
                }
            } catch (error) {
                console.error("Error fetching course details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourseDetails();
    }, [courseId, cookies]);

    // Transform sections data to match GKAccordionProgress format
    const formatSectionsForAccordion = (sections) => {
        if (!sections) return [];
        return sections.map((section, index) => ({
            id: index + 1,
            title: section.sectionTitle,
            topics: section.courseContent.map(content => ({
                id: content.contentId,
                topic: content.contentTitle,
                duration: content.duration || "10 min", // Add default duration if not provided
                status: content.status || "0" // Add default status if not provided
            }))
        }));
    };

    return (
        <Fragment>
            <HeaderDefault />
            {/* Header Section */}
            <Row className="mt-8">
                    <CommonHeader
                        text="Welcome to the Course"
                        subText="Easily manage the existing courses or create a new course."
                        icon={courseIcon}
                    />
            </Row>

            <section className="py-lg-5 py-5">
                <Container>
                    {loading ? (
                        <div className="d-flex justify-content-center mt-4">
                            <CircularProgress />
                        </div>
                    ) : courseDetails ? (
                        <Tab.Container defaultActiveKey="description">
                            <Row>
                                <Col xl={8} lg={12} md={12} sm={12} className="mb-4 mb-xl-0">
                                    {/* First Card: Course Title & View Course Button */}
                                    <Card className="mb-4">
                                        <Card.Body className="d-flex justify-content-between align-items-center">
                                            <h1 className="fw-semi-bold">
                                                {courseDetails.courseTitle || "Course Title"}
                                            </h1>
                                            <Button
                                                variant="primary"
                                                onClick={() => navigate(`/view-course/${courseId}`)}
                                            >
                                                View Course
                                            </Button>
                                        </Card.Body>

                                        {/* Tabs Inside the First Card */}
                                        <Nav className="nav-lt-tab px-3">
                                            <Nav.Item>
                                                <Nav.Link eventKey="description">Description</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="department">Department</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="level">Level</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="domain">Domain</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </Card>

                                    {/* Second Card: Tab Contents */}
                                    <Card className="mb-5">
                                        <Card.Body>
                                            <Tab.Content>
                                                <Tab.Pane eventKey="description">
                                                    {/* Injecting dynamic course description */}
                                                    <div>
                                                        <h3 className="mb-2">Course Descriptions</h3>
                                                        <p>{courseDetails.courseDescription || "No description available."}</p>
                                                      
                                                    </div>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="department">
                                                    <div>
                                                        <h3 className="mb-2">Course Department</h3>
                                                        <p>{courseDetails.courseDepartment|| "No department available."}</p>
                                                      
                                                    </div>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="level">
                                                <   div>
                                                        <h3 className="mb-2">Course Level</h3>
                                                        <p>{courseDetails.courseLevel || "No level available."}</p>
                                                      
                                                    </div>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="domain">
                                                    <div>
                                                        <h3 className="mb-2">Course Domain</h3>
                                                        <p>{courseDetails.courseDomain || "No domain available."}</p>
                                                      
                                                    </div>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Card.Body>
                                    </Card>
                                </Col>

                                {/* Sidebar Section */}
                                <Col xl={4} lg={12} md={12} sm={12}>
                                    <Card>
                                        <GKAccordionProgress 
                                            accordionItems={formatSectionsForAccordion(courseDetails.sections)} 
                                        />
                                    </Card>
                                </Col>
                            </Row>
                        </Tab.Container>
                    ) : (
                        <div className="text-center">No course details available.</div>
                    )}
                </Container>
            </section>
        </Fragment>
    );
};

export default AboutCourse;



